
import { useOtpSender } from './useOtpSender';
import { useOtpVerifier } from './useOtpVerifier';
import { OnboardingStep } from './useOnboardingState';

interface EmailVerificationProps {
  email: string;
  name: string;
  setExpectedOtp: (otp: string) => void;
  setResendDisabled: (disabled: boolean) => void;
  setCountdown: (count: number) => void;
  setStep: (step: OnboardingStep) => void;
  setIsLoading: (loading: boolean) => void;
  setEmailError: (error: string) => void;
  loadUserData: () => void;
}

export const useEmailVerification = (props: EmailVerificationProps) => {
  const { 
    handleEmailContinue, 
    handleResendOtp,
    sendOtpViaSms
  } = useOtpSender({
    email: props.email,
    setExpectedOtp: props.setExpectedOtp,
    setResendDisabled: props.setResendDisabled,
    setCountdown: props.setCountdown,
    setStep: props.setStep,
    setIsLoading: props.setIsLoading,
    setEmailError: props.setEmailError
  });

  const { 
    handleOtpComplete 
  } = useOtpVerifier({
    email: props.email,
    name: props.name,
    setStep: props.setStep,
    loadUserData: props.loadUserData
  });

  return {
    handleEmailContinue,
    handleResendOtp,
    sendOtpViaSms,
    handleOtpComplete
  };
};
